import type { CMSConfig } from '#types/config/components/cms'

export default {
  defaultTitleColor: '#2a2a2a',
  defaultBorderColor: '#e1e1e1'
} satisfies CMSConfig['accordion']
